import { z } from 'zod'

// Census regions, including DC. This lookup is bundled for offline installations.
export const HOST_REGIONS = {
  Northeast: ['CT', 'ME', 'MA', 'NH', 'RI', 'VT', 'NJ', 'NY', 'PA'],
  Midwest: ['IL', 'IN', 'MI', 'OH', 'WI', 'IA', 'KS', 'MN', 'MO', 'NE', 'ND', 'SD'],
  South: [
    'DE',
    'DC',
    'FL',
    'GA',
    'MD',
    'NC',
    'SC',
    'VA',
    'WV',
    'AL',
    'KY',
    'MS',
    'TN',
    'AR',
    'LA',
    'OK',
    'TX',
  ],
  West: ['AZ', 'CO', 'ID', 'MT', 'NV', 'NM', 'UT', 'WY', 'AK', 'CA', 'HI', 'OR', 'WA'],
} as const
export const HostRegion = z.enum(['Northeast', 'Midwest', 'South', 'West'])
export type HostRegionCode = z.infer<typeof HostRegion>
export const HOST_STATES = Object.values(HOST_REGIONS).flat().sort()
export const HostState = z.enum(HOST_STATES)
export type HostStateCode = z.infer<typeof HostState>
export function hostRegion(state: HostStateCode): HostRegionCode {
  return (Object.keys(HOST_REGIONS) as HostRegionCode[]).find(region =>
    (HOST_REGIONS[region] as readonly string[]).includes(state)
  )!
}
